<template>
  <div class="container">
    <!-- <div class="title is-3 has-text-centered">{{ $t("student") }}</div> -->
    <div class="columns">
      <div class="column is-4">
        <program-selector @program-selected="program_selected" />
      </div>
      <div class="column">
        <program-pensums ref="program_pensums" />
      </div>
    </div>
  </div>
</template>

<script>
import { warning_message, get } from "@/utils";
import ProgramSelector from "./pensum/ProgramSelector.vue";
import ProgramPensums from "./pensum/ProgramPensums.vue";

export default {
  name: "StudentIndex",
  components: { ProgramSelector, ProgramPensums },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    program_selected(program) {
      let v = this;
      v.$refs.program_pensums.refresh_pensums(program);
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
